import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 申明 state 接口类型
interface StateDataType {
  globalTxt: Object;
  token: string;
  member_id: string;
  CLASS_NAME: string;
  currentChild: Object;//当前学生的个人信息
  isPlay: Boolean;//背景音乐是否播放
  answer_list: any;//保存答案
  remainTime: Number;//考试剩余时间
  InfoNameQuestion: any;//当前试题的名称 - 考试头部
  InfoAllQuestion: any;//总共题目数 - 考试头部
  InfocurrentQuestion: any;//当前第几题 - 考试头部
  InfoNameQuestion1: any;//题目分析 - 当前试题的名称 - 考试头部
  InfoAllQuestion1: any;//题目分析 - 总共题目数 - 考试头部
  InfocurrentQuestion1: any;//题目分析 - 当前第几题 - 考试头部
  textBookId: any;//当前点击的教材id
  textbookCnname: any;//当前点击的教材名称
  videoSrc: any;
  isLoading: Boolean; // 加载动画
  getCodeInfo:any;//考试提交获取的信息
  languageType: string;//简转繁
  undonenums: string;//作业的数量
  has_num: Boolean;//作业的数量
}

var state: StateDataType = {
  globalTxt: {},
  token: '',
  member_id: '',
  CLASS_NAME: '1',
  currentChild: {},//当前孩子的信息
  isPlay: false,
  answer_list: [],//保存答案
  remainTime: 0,//考试剩余时间
  InfoNameQuestion: '',//当前试题的名称 - 考试头部
  InfoAllQuestion: '',//总共题目数 - 考试头部
  InfocurrentQuestion: '',//当前第几题 - 考试头部
  InfoNameQuestion1: '',//题目分析 - 当前试题的名称 - 考试头部
  InfoAllQuestion1: '',//题目分析 - 总共题目数 - 考试头部
  InfocurrentQuestion1: '',//题目分析 - 当前第几题 - 考试头部
  textBookId: '',//当前点击的教材id
  textbookCnname: '',//当前点击的教材名称
  videoSrc: '',
  isLoading: false,
  getCodeInfo:'',//考试提交获取的信息
  languageType: 'zh',//简转繁 默认简体
  undonenums: '0',//作业的数量
  has_num: false//作业的数量
}

export default new Vuex.Store({
  state,
  mutations: {
    setGlobalTxt(state: StateDataType, obj: object) {
      state.globalTxt = obj
    },
    setUserToken(state: StateDataType, token: string) {
      state.token = token
    },
    setMemberId(state: StateDataType, member_id: string) {
      state.member_id = member_id
    },
    setCurrentChild(state: StateDataType, currentChild: object) {
      state.currentChild = currentChild
    },
    setbgMusic(state: StateDataType, isPlay: boolean) {
      state.isPlay = isPlay
    },
    setAnswerList(state: StateDataType, answer_list: any) {
      state.answer_list = answer_list
    },
    setRemainTime(state: StateDataType, remainTime: any) {
      state.remainTime = remainTime
    },
    setInfoNameQuestion(state: StateDataType, InfoNameQuestion: any) {
      state.InfoNameQuestion = InfoNameQuestion
    },
    setInfoAllQuestion(state: StateDataType, InfoAllQuestion: any) {
      state.InfoAllQuestion = InfoAllQuestion
    },
    setInfocurrentQuestion(state: StateDataType, InfocurrentQuestion: any) {
      state.InfocurrentQuestion = InfocurrentQuestion
    },
    setInfoNameQuestion1(state: StateDataType, InfoNameQuestion1: any) {
      state.InfoNameQuestion1 = InfoNameQuestion1
    },
    setInfoAllQuestion1(state: StateDataType, InfoAllQuestion1: any) {
      state.InfoAllQuestion1 = InfoAllQuestion1
    },
    setInfocurrentQuestion1(state: StateDataType, InfocurrentQuestion1: any) {
      state.InfocurrentQuestion1 = InfocurrentQuestion1
    },
    settextBookId(state: StateDataType, textBookId: any) {
      state.textBookId = textBookId
    },
    settextbookCnname(state: StateDataType, textbookCnname: any) {
      state.textbookCnname = textbookCnname
    },
    setvideoSrc(state: StateDataType, videosrcData: any) {
      state.videoSrc = videosrcData
    },

    setLoadingStatus(state: StateDataType, status: any) {
      state.isLoading = status
    },
    setgetCodeInfo(state: StateDataType, getCodeInfo: any) {
      state.getCodeInfo = getCodeInfo
    },
    //简转繁
    setLanguageType(state: StateDataType, languageType: any) {
      state.languageType = languageType
    },
    //作业的数量
    setundonenums(state: StateDataType, undonenums: any) {
      state.undonenums = undonenums
    },
    sethas_num(state: StateDataType, has_num: any) {
      state.has_num = has_num
    },
  },
  actions: {
    setGlobalTxt(context: any, obj: object) {
      context.commit('setGlobalTxt', obj)
    },
    setUserToken(context: any, token: string) {
      context.commit('setUserToken', token)
    },
    setMemberId(context: any, member_id: string) {
      context.commit('setMemberId', member_id)
    },
    setCurrentChild(context: any, currentChild: object) {
      context.commit('setCurrentChild', currentChild)
    },
    setbgMusic(context: any, isPlay: boolean) {
      context.commit('setbgMusic', isPlay)
    },
    setAnswerList(context: any, answer_list: any) {
      context.commit('setAnswerList', answer_list)
    },
    setRemainTime(context: any, remainTime: any) {
      context.commit('setRemainTime', remainTime)
    },
    setInfoNameQuestion(context: any, InfoNameQuestion: any) {
      context.commit('setInfoNameQuestion', InfoNameQuestion)
    },
    setInfoAllQuestion(context: any, InfoAllQuestion: any) {
      context.commit('setInfoAllQuestion', InfoAllQuestion)
    },
    setInfocurrentQuestion(context: any, InfocurrentQuestion: any) {
      context.commit('setInfocurrentQuestion', InfocurrentQuestion)
    },
    setInfoNameQuestion1(context: any, InfoNameQuestion1: any) {
      context.commit('setInfoNameQuestion1', InfoNameQuestion1)
    },
    setInfoAllQuestion1(context: any, InfoAllQuestion1: any) {
      context.commit('setInfoAllQuestion1', InfoAllQuestion1)
    },
    setInfocurrentQuestion1(context: any, InfocurrentQuestion1: any) {
      context.commit('setInfocurrentQuestion1', InfocurrentQuestion1)
    },
    settextBookId(context: any, textBookId: any) {
      context.commit('settextBookId', textBookId)
    },
    settextbookCnname(context: any, textbookCnname: any) {
      context.commit('settextbookCnname', textbookCnname)
    },
    setLoadingStatus(context: any, status: any) {
      context.commit('setLoadingStatus', status)
    },
    setgetCodeInfo(context: any, getCodeInfo: any) {
      context.commit('setgetCodeInfo', getCodeInfo)
    },
    //简转繁
    setLanguageType(context: any, languageType: any) {
      context.commit('setLanguageType', languageType)
    },
    //简转繁
    setundonenums(context: any, undonenums: any) {
      context.commit('setundonenums', undonenums)
    },
    sethas_num(context: any, has_num: any) {
      context.commit('sethas_num', has_num)
    },
  },
  modules: {
  }
})

